import { useCallback, useEffect, useState } from 'react';

import { fetchFolders } from '../lib/api-client';
import type { Folder } from '../lib/api-client';

interface UseFoldersResult {
  folders: Folder[];
  loading: boolean;
  refetch: () => void;
}

const foldersChanged = new EventTarget();

export function useFolders(): UseFoldersResult {
  const [folders, setFolders] = useState<Folder[]>([]);
  const [loading, setLoading] = useState(true);
  const [fetchCount, setFetchCount] = useState(0);

  const refetch = useCallback(() => {
    foldersChanged.dispatchEvent(new Event('change'));
  }, []);

  useEffect(() => {
    const handler = () => setFetchCount((c) => c + 1);
    foldersChanged.addEventListener('change', handler);
    return () => foldersChanged.removeEventListener('change', handler);
  }, []);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchFolders()
      .then((data) => {
        if (!cancelled) {
          setFolders(data);
          setLoading(false);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [fetchCount]);

  return { folders, loading, refetch };
}
